const initDirective = {
    created(el, binding, vnode, prevVnode) {
        const vm = binding.instance
        var arg = toCamelCase(binding.arg)
        vm.$data[arg] = binding.value
    }
}

function toCamelCase(str) {
    return str.toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });    
}